import { useMutation } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { FormulaAttributesEnum } from '../contracts'

export interface ICreateRefundRulesInputType {
  productId: number;
  states: number[];
  headquarters: number[];
  ruleType: string;
  ruleName?: string | null;
  startDate: Date;
  endDate: Date;
  discountRanges: IDiscountRanges[];
  formulaAttributes: FormulaAttributesEnum[];
}

export interface IRefundRules {
  rulesId: number;
  typeId: number;
  startDate: Date;
  endDate: Date;
  ruleName?: string;
  createdAt: Date;
  discountRanges: IDiscountRanges;
}

export interface IDiscountRanges {
  discount: number;
  discountRefund: number
}

export function useCreateRefundRules() {
  const { request } = usePbm2Url();
  return useMutation('createRefundRules', async (variables: ICreateRefundRulesInputType) => {
    const { Refund_createRefundRulesMutation }  = await request(
      gql`
        mutation ($input: Refund_CreateRefundRulesInputType!) {
            Refund_createRefundRulesMutation(input: $input) {
                rulesId,
                typeId,
                states,
                headquarters,
                startDate,
                endDate,
                ruleName,
                createdAt,
                discountRanges {
                    discount,
                    discountRefund
                },
                formulaAttributes
            }
        }
      `,
      {
        input: {
            productId: variables.productId,
            states: variables.states,
            headquarters: variables.headquarters,
            ruleType: variables.ruleType,
            ruleName: variables.ruleName,
            startDate: variables.startDate,
            endDate: variables.endDate,
            discountRanges: variables.discountRanges,
            formulaAttributes: variables.formulaAttributes,
        } as ICreateRefundRulesInputType,
      }
    );
    return Refund_createRefundRulesMutation as IRefundRules;
  });
}
